import script from "./MyChart.vue?vue&type=script&lang=js"
export * from "./MyChart.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__